import { ContourEditBlocker } from '~/domain/dicom/contourEditBlocker';

/**
 * Message id naming the guard that actually blocks the edit; precedence is
 * decided by `resolveContourEditBlocker`.
 */
export function editBlockedMessageId(blocker: ContourEditBlocker): string {
    return blocker === 'lock'
        ? 'structureLockedCannotBeModified'
        : 'structureCannotBeModified';
}

/**
 * Toolbar tooltip reason naming the guard that blocks the action, for the
 * short "{tool} — {reason}" form rather than the full sentence above.
 */
export function editBlockedReasonId(blocker: ContourEditBlocker): string {
    return blocker === 'lock'
        ? 'tool.disabled.locked'
        : 'tool.disabled.approved';
}
